export const surveyTypes = {
  QU: 'QU',
  IR: 'IR',
  OQ: 'OQ',
  MC: 'MC',
  TIPS: 'TIPS',
  INTRO: 'INTRO',
  AD: 'AD',
  REPORT: 'RPT',
  RPTDIGITAL: 'RPTD',
  RN: 'RN',
};

export const feedbackTypes = {
  SELF: 'SELF',
  MGR: 'MANAGER',
  DIR_REPORT: 'DIRECT_REPORT',
  COLLEAGUE: 'COLLEAGUE',
  OTHER: 'OTHER',
};

export const ANIMATION_DELAY = 200;
export const DEBOUNCING_DELAY = 500;
export const HIGHLIGHT_RATER_DELAY = 3000;
export const COOKIE_DIGITALRPT_TIMEOUT = 4 * 60 * 60 * 1000; // 4 Hours

export const DOMAINS_NOT_MAPPED = [
  'https://talentcentral-1a.in.shl.zone',
  'https://talentcentral-2b.eu.shl.zone',
  'https://talentcentral-2a.eu.shl.zone',
  'https://talentcentral-3a.eu.shl.zone',
];

export const defaultTaskPageLabels = {
  label: 'label',
  label1: 'label1',
  label2: 'label2',
  label3: 'label3',
  label4: 'label4',
};

export const ECS_DOMAIN = 'https://ew1-d1-dev1-ecs-gateway-public.shl.zone';
